module.exports = __webpack_public_path__ + "static/media/Informations_légales.0554ddb0.pdf";